import 'react';
import 'bootstrap';

import 'jquery';
import SlimSelect from 'slim-select';
(window as any).SlimSelect = SlimSelect;

import './jquery';
import './notifications';
import './maintanance';
import './emailVerification';
import './mfaLoginSetup';


import { Tooltip, Toast, Popover, Carousel, Alert, Button, Collapse, Dropdown, Modal, Offcanvas, ScrollSpy, Tab } from 'bootstrap';

$(function() {
    $("[data-bs-toggle=popover]").popover();
});
